import PagedTable from '../../components/sorted-table/PagedTable';
import ActionMenu, { ActionButton } from '../../components/action-buttons/ActionButtons';
import { getAccountsOData } from '../../api/accountApi';
import { StandardParamsToODataParams, Account } from '../../types/interfaces';
import { TABLE_HEADER_CONSTANTS, LABEL_CONSTANTS } from '../../constants/common';

type DisableAccountsProps = {
  refresh: number;
  buildFilter: () => string;
  handleActionButtons: (account: Account) => ActionButton[];
  billingDisabledAccountsData: Account[];
};

const CurrentDisabledAccountsTable = ({ refresh, buildFilter, handleActionButtons, billingDisabledAccountsData }: DisableAccountsProps) => {
  return (
    <>
      <div className="desk-billing-management">
        <PagedTable
          headers={[
            { displayName: TABLE_HEADER_CONSTANTS.ACCOUNT_OWNER },
            { displayName: TABLE_HEADER_CONSTANTS.START_MONTH },
            { displayName: TABLE_HEADER_CONSTANTS.END_MONTH },
            { displayName: TABLE_HEADER_CONSTANTS.PERMANENTLY_DISABLED },
            { displayName: TABLE_HEADER_CONSTANTS.ACTION },
          ]}
          getData={params => getAccountsOData(StandardParamsToODataParams({ ...params, filter: buildFilter() }))}
          pageSize={8}
          minHeight={140}
          height={325}
          refresh={refresh}
          noResultsMessage={LABEL_CONSTANTS.NO_DISABLED_ACCOUNTS_FOUND}
          buildRow={account => [
            account.name,
            account.billingOffStartMonth
              ? new Date(account.billingOffStartMonth).toLocaleString('en-US', { month: 'long', year: 'numeric' })
              : '--',
            account.billingOffEndMonth
              ? new Date(account.billingOffEndMonth).toLocaleString('en-US', { month: 'long', year: 'numeric' })
              : '--',
            !account.billingOffEndMonth ? 'Yes' : 'No',
            <ActionMenu actionButtons={handleActionButtons(account)} />,
          ]}
        />
      </div>
      <div className="xs-billing-management">
        {billingDisabledAccountsData.length === 0 ? (
          <div className="result-item">{`${LABEL_CONSTANTS.NO_DISABLED_ACCOUNTS_FOUND}.`}</div>
        ) : (
          billingDisabledAccountsData.map((account, index) => (
            <div className="card max-width" key={`account-${account?.accountId}-${index}`}>
              <div className="billing-management-card">
                <div className="billing-management-content">
                  <div className="billing-info">
                    <div className="billing-content">
                      <label>{`${TABLE_HEADER_CONSTANTS.ACCOUNT_OWNER} : `}</label>
                      <label>{account?.name}</label>
                    </div>
                    <div className="billing-content">
                      <label>{`${TABLE_HEADER_CONSTANTS.START_MONTH} : `}</label>
                      <label>
                        {account?.billingOffStartMonth ? new Date(account.billingOffStartMonth).toLocaleDateString() : '--'}
                      </label>
                    </div>
                  </div>
                  <div className="billing-info">
                    <div className="billing-content">
                      <label>{`${TABLE_HEADER_CONSTANTS.END_MONTH} : `}</label>
                      <label>
                        {account?.billingOffEndMonth ? new Date(account.billingOffEndMonth).toLocaleDateString() : '--'}
                      </label>
                    </div>
                    <div className="billing-content">
                      <label>{`${TABLE_HEADER_CONSTANTS.PERMANENTLY_DISABLED} : `}</label>
                      <label>{account?.billingOffEndMonth == null ? 'Yes' : 'No'}</label>
                    </div>
                  </div>
                </div>
                <div className="action-button">
                  <ActionMenu actionButtons={handleActionButtons(account)} />
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );
};

export default CurrentDisabledAccountsTable;
